
export default {

    update(context, product, id, success, error) {
        context.$http.put('products/' + id, product).then(success, error)
    },
    changeRule(context, product, id, success, error) {
        context.$http.put('products/repricing/' + id, product).then(success, error)
    },
    saveExperiment(context, product, id, success, error) {
        context.$http.put('products/experiment/' + id, product).then(success, error)
    },
    getSimilar(context, id, success, error) {
        context.$http.get('products/similar/' + id).then(success, error)
    },

}


// WEBPACK FOOTER //
// ./src/services/product/index.js